import { useEffect } from 'react';

export default function NoIndex() {
  useEffect(() => {
    let tag = document.querySelector('meta[name="robots"]');
    const previous = tag ? tag.getAttribute('content') : null;
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute('name', 'robots');
      document.head.appendChild(tag);
    }
    tag.setAttribute('content', 'noindex, nofollow');
    return () => {
      if (previous === null) {
        // remove the tag if it did not exist before
        if (tag && tag.parentNode) tag.parentNode.removeChild(tag);
      } else if (tag) {
        tag.setAttribute('content', previous);
      }
    };
  }, []);
  return null;
}


